import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { showSnack } from './snackbarActions';
import { closeReportsSidePane } from './sidePaneActions';
import { formatErrorText } from '../../helpers/errorTextFormatter';
import addDays from 'date-fns/add_days';
export var GET_USER_REPORTS_REQUESTED = 'GET_USER_REPORTS_REQUESTED';
export var GET_USER_REPORTS_SUCCESS = 'GET_USER_REPORTS_SUCCESS';
export var GET_USER_REPORTS_ERROR = 'GET_USER_REPORTS_ERROR';
export var GET_USER_REPORT_WRITER_RESULTS_REQUESTED = 'GET_USER_REPORT_WRITER_RESULTS_REQUESTED';
export var GET_USER_REPORT_WRITER_RESULTS_SUCCESS = 'GET_USER_REPORT_WRITER_RESULTS_SUCCESS';
export var GET_USER_REPORT_WRITER_RESULTS_ERROR = 'GET_USER_REPORT_WRITER_RESULTS_ERROR';
export var ADD_REPORT = 'ADD_REPORT';
export var getUserReports = function getUserReports(UserId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var reports;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(getUserReportsRequested());
              _context.next = 3;
              return dispatch(callAPI('GetUserReportTickets', {
                UserId: UserId
              }));
            case 3:
              reports = _context.sent;
              dispatch(getUserReportsSuccess(reports));
            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getUserReportsRequested = function getUserReportsRequested() {
  return {
    type: GET_USER_REPORTS_REQUESTED
  };
};
export var getUserReportsSuccess = function getUserReportsSuccess(payload) {
  return {
    type: GET_USER_REPORTS_SUCCESS,
    payload: payload
  };
};
export var getUserReportWriterResults = function getUserReportWriterResults() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var UserId, reports;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              dispatch(getUserReportWriterResultsRequested());
              _context2.next = 4;
              return dispatch(callAPI('GetUserReportWriterResultRecords', {
                UserId: UserId
              }));
            case 4:
              reports = _context2.sent;
              dispatch(getUserReportWriterResultsSuccess(reports));
            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getUserReportWriterResultsRequested = function getUserReportWriterResultsRequested() {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_REQUESTED
  };
};
export var getUserReportWriterResultsSuccess = function getUserReportWriterResultsSuccess(payload) {
  return {
    type: GET_USER_REPORT_WRITER_RESULTS_SUCCESS,
    payload: payload
  };
};
var createParamsForOneOffReport = function createParamsForOneOffReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;
  return {
    OMSId: OMSId,
    startTime: addDays(formValues.startDate, 1),
    endTime: addDays(formValues.endDate, 1),
    accountIdList: formValues.accountIdList
  };
};
export var generateReport = function generateReport(formValues) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var params, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = createParamsForOneOffReport(getState, formValues);
              response = void 0;
              _context3.t0 = formValues.type;
              _context3.next = _context3.t0 === 'TradeActivity' ? 5 : _context3.t0 === 'Transaction' ? 9 : _context3.t0 === 'Treasury' ? 13 : 17;
              break;
            case 5:
              _context3.next = 7;
              return dispatch(callAPI('GenerateTradeActivityReport', params));
            case 7:
              response = _context3.sent;
              return _context3.abrupt('break', 19);
            case 9:
              _context3.next = 11;
              return dispatch(callAPI('GenerateTransactionActivityReport', params));
            case 11:
              response = _context3.sent;
              return _context3.abrupt('break', 19);
            case 13:
              _context3.next = 15;
              return dispatch(callAPI('GenerateTreasuryActivityReport', params));
            case 15:
              response = _context3.sent;
              return _context3.abrupt('break', 19);
            case 17:
              console.error('Unsupported \'' + formValues.type + '\' report type');
              return _context3.abrupt('return');
            case 19:
              if (!(response.bAccepted === false)) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt('return', dispatch(showSnack({
                id: 'REPORT_WARNING',
                type: 'warning',
                text: response.rejectMessage
              })));
            case 21:
              dispatch(addReport(response));
              dispatch(closeReportsSidePane());
              dispatch(showSnack({
                id: 'SINGLE_REPORT_SUCCESS',
                type: 'success',
                // context.t('Single report was successfully created')
                text: 'Single report was successfully created'
              }));
            case 24:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var createParamsForScheduledReport = function createParamsForScheduledReport(getState, formValues) {
  var OMSId = getState().user.userInfo.OMSId;
  return {
    OMSId: OMSId,
    frequency: formValues.frequency,
    beginTime: formValues.startDate,
    accountIdList: formValues.accountIdList
  };
};
export var scheduleReport = function scheduleReport(formValues) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var params, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              params = createParamsForScheduledReport(getState, formValues);
              response = void 0;
              _context4.t0 = formValues.type;
              _context4.next = _context4.t0 === 'TradeActivity' ? 5 : _context4.t0 === 'Transaction' ? 9 : _context4.t0 === 'Treasury' ? 13 : 17;
              break;
            case 5:
              _context4.next = 7;
              return dispatch(callAPI('ScheduleTradeActivityReport', params));
            case 7:
              response = _context4.sent;
              return _context4.abrupt('break', 19);
            case 9:
              _context4.next = 11;
              return dispatch(callAPI('ScheduleTransactionActivityReport', params));
            case 11:
              response = _context4.sent;
              return _context4.abrupt('break', 19);
            case 13:
              _context4.next = 15;
              return dispatch(callAPI('ScheduleTreasuryActivityReport', params));
            case 15:
              response = _context4.sent;
              return _context4.abrupt('break', 19);
            case 17:
              console.error('Unsupported \'' + formValues.type + '\' report type');
              return _context4.abrupt('return');
            case 19:
              if (!(response.bAccepted === false)) {
                _context4.next = 21;
                break;
              }
              return _context4.abrupt('return', dispatch(showSnack({
                id: 'CYCLICAL_REPORT_ERROR',
                type: 'warning',
                text: response.rejectMessage
              })));
            case 21:
              dispatch(addReport(response));
              dispatch(closeReportsSidePane());
              dispatch(showSnack({
                id: 'CYCLICAL_REPORT_SUCCESS',
                type: 'success',
                // context.t('Cyclical report was successfully created')
                text: 'Cyclical report was successfully created'
              }));
            case 24:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var addReport = function addReport(payload) {
  return {
    type: ADD_REPORT,
    payload: payload
  };
};
export var cancelReport = function cancelReport(UserReportId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var UserId, response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              UserId = getState().user.userInfo.UserId;
              _context5.next = 3;
              return dispatch(callAPI('CancelUserReport', {
                UserReportId: UserReportId
              }));
            case 3:
              response = _context5.sent;
              if (response.result) {
                dispatch(getUserReports(UserId));
              } else {
                dispatch(showSnack({
                  id: 'CANCEL_REPORT_ERROR',
                  text: formatErrorText(response),
                  type: 'warning'
                }));
              }
            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};